import React from "react";
import Buttond from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { config } from "../../../../constants";
import { Modal, Button as ButtonBootstrap } from "react-bootstrap";
import apiClient from '../../../../utils/apiClient';
const url = config.url.URL; //"http://localhost:52344";

export default class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmDialog: false,
      microserviceName: props.microserviceName,
      key: 0,
      showNoDisableModal: false,
      inEditMode: false,
      confirmationMessage: "Are you sure you want to change status?",
      status: false,
      message: "",
    };
  }

  callDelete = (e) => {
    apiClient.delete(`${url}/${this.state.microserviceName}`, {
      headers: {
        key: this.state.key,
      },
    })
      .then((response) => {
        const data = response.data;
        if (data.statusCode == 200) {
          this.props.editfunction(this.state.status);
          this.props.refreshfunction();
        }
        else {
          if (data.statusCode == 400) {
            if (data.headers[0] && (data.headers[0].key == 'ConflictType')) {
              this.setState({ message: data.headers[1].value[0] });
            }
            else {
              this.setState({ message: this.props.msg });
            }
          }
          else if (data.statusCode == 500) {
            if (data.headers[0]) {
              this.setState({ message: data.headers[0].value[0] });
            }
            else {
              this.setState({ message: "An error occurred! Can't apply required changes, please contact support." });
            }
          }
          
          this.setState({ showNoDisableModal: true });
        }
      });

    this.setState({ showConfirmDialog: false });
  };

  handleCloseConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });

    if (this.state.inEditMode == true) {
      this.props.refreshfunction();
    }
  };

  handleChangeConfirmMessageAndOpenDialog = (msg) => {
    this.setState({ confirmationMessage: msg }, this.handleOpenConfirmDialog());
  };

  handleOpenConfirmDialog = () => {
    this.setState({ showConfirmDialog: true });
  };

  handleCloseDisableDialog = () => {
    this.setState({ showNoDisableModal: false });

    if (this.state.inEditMode == true) {
      this.props.refreshfunction();
    }
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.showConfirmDialog}
          onClose={this.handleCloseConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ fontSize: "14px", marginBottom: "-10px" }}
          >
            {"Confirmation"}{" "}
            <div
              style={{ display: "inline", float: "right", cursor: "pointer" }}
              onClick={this.handleCloseConfirmDialog}
            >
              X
            </div>
          </DialogTitle>
          <DialogContent
            style={{
              paddingTop: "10px",
              borderTop: "1px solid #b9adad",
              borderBottom: "1px solid #b9adad",
            }}
          >
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: "rgb(0,40,85)", fontSize: "14px" }}
            >
              <b>{this.state.confirmationMessage}</b>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttond
              onClick={this.callDelete}
              style={{ backgroundColor: "rgb(0,107,166)", color: "white" }}
            >
              Yes
            </Buttond>
            <Buttond
              onClick={this.handleCloseConfirmDialog}
              style={{ marginLeft: "0px" }}
            >
              No
            </Buttond>
          </DialogActions>
        </Dialog>

        <Modal
          show={this.state.showNoDisableModal}
          onHide={this.handleCloseDisableDialog}
          size="xs"
        >
          <Modal.Header closeButton>
            <Modal.Title size="h6">{this.props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{this.state.message}</p>
          </Modal.Body>

          <Modal.Footer>
            <ButtonBootstrap
              variant="secondary"
              className="btnSecondary"
              onClick={this.handleCloseDisableDialog}
            >
              {" "}
              OK{" "}
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
